// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"8dd333c0d4c738f94bb8","303":"b69cc39bb920c855df01","495":"1dff7baf1424d8857ba5"}[chunkId] + ".js";
};